import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
            漫画分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            按分类浏览，快速找到你喜欢的韩漫类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {comicCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-100 hover:bg-primary-50 rounded-lg transition-all duration-200"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-md bg-background-50 group-hover:bg-primary-100/50 text-accent-500 group-hover:text-primary-500 transition-colors duration-200">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-900 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}